import React from 'react'
import { LineItemContainer } from 'src/shared/components/offer-price/offer-line-item/ui/line-item-container'
import { LineItemLabel } from 'src/shared/components/offer-price/offer-line-item/ui/line-item-label'
import { LineItemPriceContainer } from 'src/shared/components/offer-price/offer-line-item/ui/line-item-price-container'
import { LineItemTitleContainer } from 'src/shared/components/offer-price/offer-line-item/ui/line-item-title-container'
export const LineSkeleton = () => {
  return (
    <LineItemContainer>
      <LineItemTitleContainer>
        <input type="radio" name="..." checked={false} />
        <LineItemLabel>...</LineItemLabel>
      </LineItemTitleContainer>
      <div>
        <LineItemPriceContainer>
          <LineItemLabel>...</LineItemLabel>
        </LineItemPriceContainer>
      </div>
    </LineItemContainer>
  )
}
